import {createAddressButtonStyles} from "@insite/content-library/Widgets/Addresses/CreateAddressButton"
import { css } from "styled-components";

createAddressButtonStyles.overflowMenu= {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}